// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__jAHaQ","info":"PatientInfo_info__3CXV1"};